import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { useLabels } from '@/features/labels/labels.hooks';
import LabelsTable from '@/features/labels/labels.table';

export const LabelsPanel = ({
  params,
  path,
  basePath,
  ...panelProps
}: RoutedPanelProps) => {
  // TODO: include softdeleted labelt here, but nowhere else
  const resource = useLabels();
  return (
    <Panel {...panelProps}>
      <LabelsTable {...resource} />
    </Panel>
  );
};
